import createCustomElementWrapper from './utils/createCustomElementWrapper';
export var KatPopover = createCustomElementWrapper('kat-popover', 'KatPopover', {
    'disableMobileFullWidth': 'disable-mobile-full-width',
    'hideBehavior': 'hide-behavior',
    'katAriaBehavior': 'kat-aria-behavior',
    'triggerType': 'trigger-type',
}, {
    'onHide': 'hide',
    'onShow': 'show',
}, [
    'trigger',
]);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amzn/katal-react/es/popover.js
// module id = 1244
// module chunks = 0